import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { companyAIRoutes } from '../routes/companyAIContext';
import { integrationRoutes } from '../views/integrations/routes';

import NProgress from 'nprogress';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'signin',
    component: () => import('../views/auth/SignIn/index.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/SignUp",
    name: "SignUp",
    component: () => import("../views/auth/SignUp/index.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../views/auth/ForgetPassword/index.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/forgertPasswordApply',
    name: 'forgotPasswordApply',
    component: () => import('../views/auth/ForgetPassword/apply.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/documentPage',
    name: 'document',
    component: () => import('../views/documents/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'DOCUMENT_VIEW'
    }
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/main/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboard/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'DASHBOARD_VIEW'
    }
  },
  {
    path: '/Promotional',
    name: 'PromotionalPages',
    component: () => import('../views/PromotionalPages/index.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true
    }
  },
  {
    path: '/ChoosingAnAssistant',
    name: 'ChoosingAnAssistantPage',
    component: () => import('../views/ChoosingAnAssistant/index.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true
    }
  },
  {
    path: '/asistantSettings',
    name: 'asistantSettingsPage',
    component: () => import('../views/settings/asistantSettings/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profileSettings',
    name: 'profileSettingsPage',
    component: () => import('../views/settings/profileSettings/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mailSettings',
    name: 'mailSettings',
    component: () => import('../views/settings/mailSettings/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['SMTP_VIEW']
    }
  },
  {
    path: '/reports',
    name: 'reportsPage',
    component: () => import('../views/reports/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/passwordSettings',
    name: 'passwordSettings',
    component: () => import('../views/settings/passwordSettings/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/processes',
    name: 'processes',
    component: () => import('../views/actions/processes/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['PROCESS_VIEW']
    }
  },
  {
    path: '/operations',
    name: 'operations',
    component: () => import('../views/actions/operations/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'OPERATION_VIEW'
    }
  },
  {
    path: '/actions',
    name: 'actions',
    component: () => import('../views/actions/actions/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'ACTION_VIEW'
    }
  },
  {
    path: '/actions/create',
    name: 'create-action',
    component: () => import('../views/actions/actions/components/CreateAction/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'ACTION_CREATE'
    }
  },
  {
    path: '/actions/preview',
    name: 'actions-prevşew',
    component: () => import('../views/actions/actions/components/ActionPreview/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'ACTION_VIEW'
    }
  },
  {
    path: '/actions/:id',
    name: 'action-detail',
    component: () => import('../views/actions/actions/components/ActionDetail/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'ACTION_VIEW'
    }
  },
  {
    path: '/actions/:id/edit',
    name: 'ActionEdit',
    component: () => import('../views/actions/actions/components/ActionEdit/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['ACTION_UPDATE']
    }
  },
  {
    path: '/frequency',
    name: 'frequency',
    component: () => import('../views/actions/frequency/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['FREQUENCY_VIEW']
    }
  },
  {
    path: '/sql-builder',
    name: 'sql-builder',
    component: () => import('../views/sqlBuilder/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'SQL_BUILDER_FULL_ACCESS'
    }
  },
  {
    path: '/persistent-query',
    name: 'persistent-query',
    component: () => import('../views/persistentQuery/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('../views/admin/users/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['USER_ADMIN_READ']
    }
  },
  {
    path: '/admin/roles',
    name: 'admin-roles',
    component: () => import('../views/admin/roles/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['USER_ADMIN_READ', 'ROLE_VIEW']
    }
  },
  {
    path: '/admin/feedbacks',
    name: 'admin-feedbacks',
    component: () => import('../views/admin/feedbacks/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: 'CONVERSATION_FEEDBACK_READ'
    }
  },
  {
    path: '/admin/departments',
    name: 'admin-departments',
    component: () => import('../views/admin/departments/index.vue'),
    meta: {
      requiresAuth: true,
      requiredPermissions: ['USER_ADMIN_READ', 'DEPARTMENT_VIEW']
    }
  },
  ...companyAIRoutes,
  {
    path: '/ai',
    name: 'ai-test',
    component: () => import('../views/ai-test/index.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true
    }
  },
  ...integrationRoutes,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

// NProgress'i route değişimlerinde başlat ve durdur
router.beforeEach((_to, _from, next) => {
  NProgress.start(); // Yükleme başlarken progress bar başlasın
  next();
});

router.afterEach(() => {
  NProgress.done(); // Yükleme bittiğinde progress bar durdurulsun
});

export default router;
